const SET_ATTRIBUTES_SELECTIONS = "SET_ATTRIBUTES_SELECTIONS";
const ADD_ATTRIBUTE_SELECTION = "ADD_ATTRIBUTE_SELECTION";
export { SET_ATTRIBUTES_SELECTIONS, ADD_ATTRIBUTE_SELECTION };
